import React, {useMemo} from 'react';
import classNames from 'classnames';
import { Collapse, List, ListItem, ListItemText } from '@material-ui/core';
import css from '~/features/dashboard/components/song-details/styles.module.scss';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';
import EditIcon from '@material-ui/icons/Edit';
import Slider from 'react-slick';
import DeleteIcon from '@material-ui/icons/Delete';
import { SongPlayer } from '~/features/dashboard/components/song-player';
import {useSelector} from "react-redux";
import {getArtworkListingsList, getSoundListingsList} from "~/features/dashboard/store/selectors";
import {ItemTypeSong} from "~/features/dashboard/components/song-details/coponents/EditSynchTab";
import {sortSongItems} from "~/utils/helpers";

interface SongAssest_Prop {
    tagDetails: any;
    name?: String;
    deleteAssetsBtn: (data: any) => void;
    gotoStepSong: (data: any) => void;
    downloadImage: (img: string, type: string) => void;
    twoColumns?: boolean;
}

export const SongAssets: React.FC<SongAssest_Prop> = ({ tagDetails, deleteAssetsBtn, gotoStepSong, downloadImage, twoColumns }) => {
    function groupArrayOfObjects(list: any, key: any) {
        return list.reduce(function (rv: any, x: any) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
    const artworkAttr = useSelector(getArtworkListingsList);
    const artworkList: ItemTypeSong[] = useMemo(() => {
        if (artworkAttr && artworkAttr.length) {
            return sortSongItems(
                artworkAttr.map(i => ({ id: i.customField ? i.id : 0, customField: i.customField ? i.customField : 0, listingText: i.listingText }))
            );
        }
        return [];
    }, [artworkAttr]);

    const soundAttr = useSelector(getSoundListingsList);
    const soundList: ItemTypeSong[] = useMemo(() => {
        if (soundAttr && soundAttr.length) {
            return sortSongItems(
                soundAttr.map(i => ({ id: i.customField ? i.id : 0, customField: i.customField ? i.customField : 0, listingText: i.listingText }))
            );
        }
        return [];
    }, [soundAttr]);

    let images: any[] = [];
    let sounds: any[] = [];

    tagDetails.map((t: any) => {
        !!t.gSongFileName &&
        (t.gSongFileName.includes('.png') || t.gSongFileName.includes('.jpg') || t.gSongFileName.includes('.jpeg') || t.gSongFileName.includes('.gif'))
            ? images.push(t)
            : sounds.push(t);
        return t;
    });

    const artwork = groupArrayOfObjects(images, 'gSongArtworkTags');
    const songattr = groupArrayOfObjects(sounds, 'gSongSoundTags');

    return (
        <div style={{ width: 'auto' }}>
            <div className={css.assetsCardsTab}>
                {artworkList.map(
                    ( {listingText, id}) =>
                        artwork[listingText] && (
                            <SongAssetsImages
                                key={id}
                                tagDetails={artwork[listingText]}
                                name={listingText}
                                deleteAssetsBtn={deleteAssetsBtn}
                                gotoStepSong={gotoStepSong}
                                downloadImage={downloadImage}
                            />
                        )
                )}
                {soundList.map(
                    ( {listingText, id} ) =>
                        songattr[listingText] && (
                            <SongAssetsSounds
                                key={id}
                                tagDetails={songattr[listingText]}
                                name={listingText}
                                deleteAssetsBtn={deleteAssetsBtn}
                                gotoStepSong={gotoStepSong}
                                downloadImage={downloadImage}
                                twoColumns={twoColumns}
                            />
                        )
                )}
            </div>
        </div>
    );
};

export const SongAssetsImages: React.FC<SongAssest_Prop> = ({ tagDetails, name, deleteAssetsBtn, gotoStepSong, downloadImage }) => {
    const [openImageAssets, setOpenImageAssets] = React.useState(true);

    const NextArrow = (props: any) => {
        return <div className={css.sliderArrowNext} onClick={props.onClick} />;
    };

    const PrevArrow = (props: any) => {
        return <div className={css.sliderArrowPrev} onClick={props.onClick} />;
    };

    let settings = {
        infinite: false,
        speed: 300,
        centerMode: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <>
            {tagDetails && tagDetails.length > 0 ? (
                <div className="assetView" style={{ marginTop: '1rem' }}>
                    <ListItem onClick={() => setOpenImageAssets(!openImageAssets)} button className={css.listAssetTab}>
                        <ListItemText primary={name} color="white" />
                        {openImageAssets ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openImageAssets} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <div className={css.imageAssests}>
                                <Slider {...settings}>
                                    {tagDetails.map((t: any, i: any) => (
                                        <div className="img" key={i}>
                                            <div className={css.imgIcon}>
                                                <div className={css.deleteBtnAssets}>
                                                    <GetAppIcon className={css.valign} onClick={() => downloadImage(t.gSongFilePath, 'image')} />
                                                    <EditIcon onClick={() => gotoStepSong(t)} className={css.valign} />
                                                    <DeleteIcon onClick={() => deleteAssetsBtn(t)} className={css.valign} />
                                                </div>
                                                <a
                                                    download={t.gSongFileName}
                                                    href={t.gSongFilePath}
                                                    target="_blank"
                                                    title={t.gSongFileName}
                                                    rel="noopener noreferrer"
                                                >
                                                    <img key={i} src={t.gSongFilePath} alt={t.gSongFileName} width="150px" height="150px" />
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </List>
                    </Collapse>
                    {/* <Typography variant={'subtitle1'} className={css.assetName}>
                        {name}
                    </Typography> */}
                </div>
            ) : (
                ''
            )}
        </>
    );
};

export const SongAssetsSounds: React.FC<SongAssest_Prop> = ({ tagDetails, name, deleteAssetsBtn, gotoStepSong, downloadImage, twoColumns = false }) => {
    const [openSong, setOpenSong] = React.useState(true);
    return (
        <>
            {tagDetails && tagDetails.length > 0 ? (
                <div style={{ marginTop: '1rem' }}>
                    <ListItem onClick={() => setOpenSong(!openSong)} button className={css.listAssetTab}>
                        <ListItemText primary={name} color="white" />
                        {openSong ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openSong} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding className={css.songAssets}>
                            {tagDetails.map((t: any, i: any) => {
                                return (
                                    <ListItem key={t.filePath} className={classNames([css.songAssetItem, twoColumns && css.halfWidth])}>
                                        <SongPlayer editBtn song={t} editAssetsBtn={gotoStepSong} deleteAssetsBtn={deleteAssetsBtn} className={css.songAssetPlayer}/>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Collapse>
                </div>
            ) : (
                ''
            )}
        </>
    );
};
